import { AddressingResultActionTypes } from "../constants/addressingResultActionTypes";

export const fetchAddressResultRequest = (fetch_type, fetch_input) => {
  //will recive FetchType
  return {
    type: AddressingResultActionTypes.FETCH_AddressResults_REQUEST,
    payload: { fetchType: fetch_type, fetchInput: fetch_input },
  };
};

export const fetchAddressResultSuccess = (data) => {
  return {
    type: AddressingResultActionTypes.FETCH_AddressResults_SUCCESS,
    payload: data,
  };
};

export const fetchAddressResultFailure = (error) => {
  return {
    type: AddressingResultActionTypes.FETCH_AddressResults_FAILURE,
    payload: error,
  };
};

//Update Shamnas -- get data from cookies
export const fetchAddressResultFromCookie = (data) => {
  return {
    type: AddressingResultActionTypes.FETCH_DATA_FROM_COOKIES,
    payload: data,
  };
};

export const clearAddressResult = () => {
  return {
    type: AddressingResultActionTypes.CLEAR_AddressResults,
  };
};
